module.exports = __webpack_public_path__ + "static/img/right-top-row-8.33d42c54.png";